module.exports = __webpack_public_path__ + "img/wheelchair.fedf0620.svg";